import React from "react";
import { Link } from "react-router-dom";

import slide3 from "../assets/images/landingimage.jpg";

const images = require.context("../assets/images", false);

function Hero() {
  return (
    <div
      className="bg-slider static-hero"
      style={{
        backgroundImage: `url(${slide3})`,
      }}
    >
      <div className="hero-slide">
        <div className="carousel-caption hero-content">
          <h1>Unforgettable Journeys Across Incredible India</h1>
          <h3 className="specialfont hero-tagline color-white mb-3" aria-label="Bespoke private luxury">
            <span>BESPOKE</span>
            <span className="hero-tagline-separator" aria-hidden="true">*</span>
            <span>PRIVATE</span>
            <span className="hero-tagline-separator" aria-hidden="true">*</span>
            <span>LUXURY</span>
          </h3>
          <Link className="primary-btn" to="/tours">
            Explore Luxury Tours
            <img src={images("./arrow-right-btn.svg")} alt="arrow" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Hero;
